import { ConfirmationActions, SearchMeditatorActions, TableTitles } from "@/constants";
import { useDisclosure } from "@/hooks";
import { useAcceptRejectRegistrationPendingMeditators, useConfirmRejectCancellationRequest } from "@/hooks/query-hooks/useMeditators";
import { Breadcrumb, Button, Divider, Drawer } from "antd";
import { AiOutlineEye } from "react-icons/ai";
import { MeditationRetreatsTable } from "../MeditationRetreats";
import { RegistrantInformations } from "./RegistrantInformations";

export function RegistrantDetailDrawer({
    registrant,
    confirmationAction,
    Component,
    pathnameTitle = "စာရင်းသွင်းထားသော ယောဂီများ",
    drawerType,
}: {
    registrant: MeditatorWithMeditationRetreat;
    confirmationAction: ConfirmationActions;
    Component?: React.ComponentType<{ registrant: Meditator, onToggleDrawer: () => void }>;
    pathnameTitle?: string;
    drawerType: SearchMeditatorActions
}) {
    const [opened, { toggle }] = useDisclosure(false);

    const { mutate: mutateRegistrationPending, isLoading: iseMutatingRegistrationPending } = useAcceptRejectRegistrationPendingMeditators();

    const { mutate: mutateCancellationRequest, isLoading: isMutatingCancellationRequests } = useConfirmRejectCancellationRequest();

    const onSubmit = () => {
        const payload = {
            ids: [registrant.user.id],
            action: confirmationAction
        };

        switch (drawerType) {
            case SearchMeditatorActions.REGISTERATION:
                mutateRegistrationPending(payload, {
                    onSuccess: () => {
                        toggle();
                    }
                })
                break;
            case SearchMeditatorActions.CANCELLATION_REQUEST:
                mutateCancellationRequest(payload, {
                    onSuccess: () => {
                        toggle();
                    }
                });
                break;
        }
    }

    const renderColumnKeys = [
        TableTitles.retreat_start_month,
        TableTitles.retreat_level,
        TableTitles.retreat_name,
        TableTitles.retreat_duration,
        TableTitles.retreat_start_date,
        TableTitles.retreat_end_date,
        TableTitles.total_registrants,
    ];

    return (
        <>
            <Button
                type="link"
                size="large"
                onClick={toggle}
                icon={
                    <AiOutlineEye
                        size={18}
                    />
                }
            />
            <Drawer
                open={opened}
                onClose={toggle}
                closeIcon={false}
                destroyOnClose
                width={"79vw"}
                classNames={{
                    content: "!w-[cal(100% - 320px)]"
                }}
                footer={
                    <div
                        className="py-2 flex justify-end gap-4"
                    >
                        <Button
                            type="text"
                            className={"!font-poppins"}
                            size="large"
                            onClick={toggle}
                            disabled={isMutatingCancellationRequests || iseMutatingRegistrationPending}
                        >
                            Back
                        </Button>
                        <Button
                            type="primary"
                            danger
                            className={"!text-white !font-poppins bg-primary-gradient "}
                            size="large"
                            shape="round"
                            onClick={onSubmit}
                            loading={isMutatingCancellationRequests || iseMutatingRegistrationPending}
                        >
                            Confirm
                        </Button>
                    </div>
                }
                title={
                    <div
                        className="flex items-center justify-between gap-2"
                    >
                        <Breadcrumb
                            separator="/"
                            className="!mb-4"
                        >
                            <Breadcrumb.Item
                                onClick={toggle}
                                className="cursor-pointer"
                            >
                                <p
                                    className="text-base font-semibold"
                                >
                                    {pathnameTitle}
                                </p>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                className="font-poppins text-base"
                            >
                                Reg ID - {registrant.user.id}
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        {Component && <Component
                            registrant={registrant.user}
                            onToggleDrawer={toggle}
                        />}
                    </div>
                }
            >
                <div
                    className="space-y-3"
                >
                    <div
                        className="rounded shadow border border-black/10 p-4"
                    >
                        <h2
                            className="text-base font-semibold"
                        >
                            တရားစခန်း အချက်အလက်
                        </h2>
                        <Divider />
                        <MeditationRetreatsTable
                            dataSource={registrant.events || []}
                            renderColumnKeys={renderColumnKeys}
                            pagination={false}
                            hasFilter={false}
                        />
                    </div>

                    <div
                        className="h-full max-h-[420px] overflow-y-auto shadow rounded"
                    >
                        <RegistrantInformations
                            registrant={registrant.user}
                        />
                    </div>
                </div>
            </Drawer>
        </>
    )
}
